/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

const SearchIconSymbol = (props: SVGProps<SVGSVGElement>) => {
  const { color = 'var(--secondaryText)' } = props;

  return (
    (<svg
      className={props.className}
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      data-palette="SearchIconSymbol">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Contract-selection-with-Search"
          transform="translate(-170.000000, -120.000000)"
          fill={color}
          fillRule="nonzero"
          stroke={color}
          strokeWidth="0.5"
        >
          <g id="noun_Search_2479845" transform="translate(171.000000, 121.000000)">
            <g id="Group">
              <path
                d="M8.09357143,16.1907143 C5.9312381,16.1907143 3.89833333,15.3486667 2.36938095,13.8197143 C-0.786952381,10.663381 -0.786952381,5.52761905 2.36938095,2.37128571 C3.89838095,0.842333333 5.93128571,0.000238095238 8.09357143,0.000238095238 C10.2558571,0.000238095238 12.2887619,0.842333333 13.8177619,2.37128571 C16.9740476,5.52761905 16.9740476,10.663381 13.8177619,13.8197143 C12.2887619,15.3486667 10.2559048,16.1907143 8.09357143,16.1907143 Z M8.09357143,0.952619048 C6.18566667,0.952619048 4.39190476,1.69561905 3.04280952,3.0447619 C0.257809524,5.82971429 0.257809524,10.3612381 3.04280952,13.1462857 C4.39190476,14.495381 6.18566667,15.238381 8.09357143,15.238381 C10.0014762,15.238381 11.7952381,14.495381 13.1443333,13.1462857 C15.9292857,10.3612857 15.9292857,5.8297619 13.1443333,3.0447619 C11.7952381,1.69557143 10.0014762,0.952619048 8.09357143,0.952619048 Z"
                id="Shape"
              />
              <path
                d="M17.5216667,17.9997619 C17.3997619,17.9997619 17.2779524,17.9532381 17.1849524,17.8602857 L13.1443333,13.8196667 C12.958381,13.6337143 12.958381,13.3321905 13.1443333,13.1461905 C13.3303333,12.9602857 13.6317619,12.9602857 13.8178095,13.1461905 L17.8584286,17.1868095 C18.044381,17.3727619 18.044381,17.6742857 17.8584286,17.8602857 C17.765381,17.9532857 17.6435714,17.9997619 17.5216667,17.9997619 Z"
                id="Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default SearchIconSymbol;
